import { SubscriptionListResponseDto } from '@tiendanube/common';
import { RootStateType } from 'App/store';
import { StatusType } from 'commons/types';

export const SubscriptionsSelector = {
  hasMetaplans: (state: RootStateType): boolean =>
    state.subscriptions.hasMetaplans.data?.hasMetaplans ?? false,

  hasMetaplansStatus: (state: RootStateType): StatusType =>
    state.subscriptions.hasMetaplans.status,

  subscriptionsList: (
    state: RootStateType,
  ): SubscriptionListResponseDto | null =>
    state.subscriptions.subscriptionsList.data ?? null,

  subscriptionsItems: (state: RootStateType) =>
    state.subscriptions.subscriptionsList.data?.items ?? [],

  subscriptionsListStatus: (state: RootStateType): StatusType =>
    state.subscriptions.subscriptionsList.status,

  hasSubscriptions: (state: RootStateType): boolean =>
    (state.subscriptions.subscriptionsList.data?.items?.length ?? 0) > 0,

  subscriptionsByOrderId: (orderId?: string) => (state: RootStateType) =>
    (state.subscriptions.subscriptionsList.data?.items ?? []).filter(
      (s) => !orderId || String(s.initialOrderId) === String(orderId),
    ),
};
